import { differenceInCalendarDays, addDays, formatISO } from "date-fns";

// Prezzo di una singola notte: il periodo che la contiene (date incluse
// entrambe) sovrascrive il prezzo base; se nessun periodo la contiene,
// vince il base. Nessuna notte resta mai senza prezzo.
export function priceForNight(pricing, date) {
  const iso = formatISO(date, { representation: "date" });
  const period = (pricing.periods || []).find((p) => iso >= p.start && iso <= p.end);
  return period ? period.pricePerNight : pricing.basePrice;
}

// Dettaglio notte-per-notte di un soggiorno da `from` (incluso) a `to`
// (escluso, coerente con differenceInCalendarDays già usato altrove).
export function priceBreakdown(pricing, from, to) {
  const nights = differenceInCalendarDays(to, from);
  const rows = [];
  for (let i = 0; i < nights; i++) {
    const date = addDays(from, i);
    rows.push({ date, price: priceForNight(pricing, date) });
  }
  const total = rows.reduce((sum, r) => sum + r.price, 0);
  return { rows, total };
}

// Come priceBreakdown, ma accorpa le notti consecutive con lo stesso
// prezzo in un unico range — utile per non mostrare una riga per ogni
// singola notte su soggiorni lunghi.
export function priceRanges(pricing, from, to) {
  const { rows, total } = priceBreakdown(pricing, from, to);
  const ranges = [];
  for (const row of rows) {
    const last = ranges[ranges.length - 1];
    if (last && last.pricePerNight === row.price) {
      last.end = row.date;
    } else {
      ranges.push({ start: row.date, end: row.date, pricePerNight: row.price });
    }
  }
  return { ranges, total };
}

// Lowest price per night across the base price and every seasonal period.
export function lowestNightly(pricing) {
  return Math.min(pricing.basePrice, ...(pricing.periods || []).map((x) => x.pricePerNight));
}
